import React from 'react'
import { Select } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'

export default function OdvCollectionSelect({ value, onChange }) {
  const { t } = useTranslation()

  return (
    <Select
      label={t('odv.collection', 'Collection')}
      placeholder={t('form.collection.placeholder', 'Select Collection')}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      options={[
        {
          label: t('odv.collection.COF', 'COF'),
          value: 'COF',
        },
        {
          label: t('odv.collection.COF Ext', 'COF Ext'),
          value: 'COF Ext',
        },
        {
          label: t("odv.collection.Dec'd Member", "Dec'd Member"),
          value: "Dec'd Member",
        },
        {
          label: t('odv.collection.Family Entry', 'Family Entry'),
          value: 'Family Entry',
        },
        {
          label: t('odv.collection.GIANT', 'GIANT'),
          value: 'GIANT',
        },
        {
          label: t('odv.collection.Pre-1970', 'Pre-1970'),
          value: 'Pre-1970',
        },
        {
          label: t('odv.collection.Test', 'Test'),
          value: 'Test',
        },
        {
          label: t('odv.collection.World Miscellaneous', 'World Miscellaneous'),
          value: 'World Miscellaneous',
        },
      ]}
    />
  )
}
